import React, { ReactElement, useState } from "react";
import AsyncSelect from 'react-select/async';
import { useTranslation } from "react-i18next";
import { PropsValue } from "react-select";

export interface SelectOption {
  value: string;
  label: string;
}

interface EditValueListBaseProps {
  propertyValue: SelectOption[];
  isMulti: boolean;
  hasChanged: boolean;
  hasError: boolean;
  options: (inputValue: string) => Promise<SelectOption[]>;
  onChange: (value: string) => void;
}

export const EditValueListProperty = (props: EditValueListBaseProps): ReactElement => {
  const [selectedValue, setSelectedValue] = useState(props.propertyValue);

  const onChange = (value: PropsValue<SelectOption>) => {
    if(value === null) {
      setSelectedValue(null);
      props.onChange(null);
    } else if (!props.isMulti) {
      const option = value as SelectOption;
      setSelectedValue([option]);
      props.onChange(option.value);
    } else {
      const options = value as SelectOption[];
      setSelectedValue(options);
      const multiValue = options.map(o => o.value).join(",");
      props.onChange(multiValue);
    }
  };

  const { t } = useTranslation();

  return <AsyncSelect
    cacheOptions
    defaultOptions
    loadOptions={props.options}
    value={selectedValue}
    isClearable={true}
    isMulti={props.isMulti}
    menuPlacement="auto"
    menuPortalTarget={document.body}
    placeholder={`${t("command.select")}...`}
    styles={{ 
      menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
      control: (base) => ({...base, background: props.hasError ? '#ffc0c0' :  props.hasChanged ? '#ffffc0' : 'white'}),
      multiValue: (base) => ({...base, fontSize: "16px"}) //multiValue child has 85% font
    }}
    onChange={(e) => onChange(e)}
  ></AsyncSelect>;

};
